module.exports = __webpack_public_path__ + "static/numerobiologie_dalle-84cc5f81c1f4093ea2b91a36e5f0e5b9.png";